import { useCustomGetAiMappingProposalLazyQuery } from "generated/graphql";

export default function useGetAiMappingProposal() {
  const [fetch, { data, loading, error }] = useCustomGetAiMappingProposalLazyQuery();
  return [fetch, { data, loading, error }] as const;
}
